var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonOperator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 63C48.897 63 63 48.897 63 31.5C63 14.103 48.897 0 31.5 0C14.103 0 0 14.103 0 31.5C0 48.897 14.103 63 31.5 63Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 62.5C48.6208 62.5 62.5 48.6208 62.5 31.5C62.5 14.3792 48.6208 0.5 31.5 0.5C14.3792 0.5 0.5 14.3792 0.5 31.5C0.5 48.6208 14.3792 62.5 31.5 62.5Z",
    stroke: "#52B788"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 55C44.3741 55 54 49.8513 54 43.5C54 37.1487 44.3741 32 32.5 32C20.6259 32 11 37.1487 11 43.5C11 49.8513 20.6259 55 32.5 55Z",
    fill: "#52B788"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 54.5C44.098 54.5 53.5 49.5751 53.5 43.5C53.5 37.4249 44.098 32.5 32.5 32.5C20.902 32.5 11.5 37.4249 11.5 43.5C11.5 49.5751 20.902 54.5 32.5 54.5Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 38C41.0604 38 48 30.8366 48 22C48 13.1634 41.0604 6 32.5 6C23.9396 6 17 13.1634 17 22C17 30.8366 23.9396 38 32.5 38Z",
    fill: "#52B788"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 37.5C40.7843 37.5 47.5 30.5604 47.5 22C47.5 13.4396 40.7843 6.5 32.5 6.5C24.2157 6.5 17.5 13.4396 17.5 22C17.5 30.5604 24.2157 37.5 32.5 37.5Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOperator);
export default __webpack_public_path__ + "static/media/person-operator.8580322dd2f7704f5f4a55d728bf2343.svg";
export { ForwardRef as ReactComponent };